export default __webpack_public_path__ + "static/media/Group9209.e7052416.svg";